export const skyboxCommon = `
    precision highp float;
    uniform float time;
    varying vec3 vDir;
    #define PI 3.14159265359

    mat2 rot(float a) { float s=sin(a), c=cos(a); return mat2(c,-s,s,c); }
    float hash(vec2 p) { return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453); }
    float noise(vec2 p) {
        vec2 i = floor(p); vec2 f = fract(p); f = f*f*(3.0-2.0*f);
        return mix(mix(hash(i), hash(i+vec2(1,0)), f.x), mix(hash(i+vec2(0,1)), hash(i+vec2(1,1)), f.x), f.y);
    }
    vec3 palette(float t) { return vec3(0.5)+vec3(0.5)*cos(6.28318*(vec3(1.)*t+vec3(0.263,0.416,0.557))); }
`;
